// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2787e5dfdf--btn--nQaZB","title":"_2787e5dfdf--title--KiRFU"};